<template>
  <button @click="confirm_kill_process_dialog?.showModal()">Kill</button>
  <teleport to="#app">
    <dialog ref="confirm_kill_process_dialog" class="modal">
      <div class="modal-box">
        <h3 class="mb-4 text-lg font-bold">
          Xác nhận kill tiến trình {{ process_id }}
        </h3>

        <div class="modal-action">
          <form method="dialog" class="flex gap-2">
            <button class="btn" value="cancel">Hủy</button>
            <button class="btn btn-primary min-w-28" @click="handle_confirm">
              <span> Xác nhận </span>
            </button>
          </form>
        </div>
      </div>
    </dialog>
  </teleport>
</template>

<script setup lang="ts">
import { axios_instance } from "@/api/api";
import { ref } from "vue";
import { toast } from "vue3-toastify";

const confirm_kill_process_dialog = ref<HTMLDialogElement | null>();
const props = defineProps<{
  id?: string;
  process_id?: string;
}>();

const handle_confirm = async () => {
  if (!props.id) {
    toast.error("Thiếu định danh tiến trình");
    return;
  }
  try {
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `/api/v1/view/process/kill/${props.id}`,
    };

    await axios_instance.request(config);
    toast.success("Yêu cầu kill tiến trình đã được tạo.");
  } catch (error) {
    toast.error(error);
  }
};
</script>
